import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getReportsTemplate,
  type ReportsTemplateData,
} from '@services/api/report.api'

export const fetchReportsTemplate = createAsyncThunk<
  ReportsTemplateData,
  void,
  { rejectValue: string }
>(
  'api/reports/template/fetchReportsTemplate',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getReportsTemplate()

      if (response.statusCode !== 200) {
        return rejectWithValue(response.message || 'Reports template not found')
      }

      if (response.data) {
        return response.data
      }

      return rejectWithValue('Reports template not found')
    } catch (error: unknown) {
      return rejectWithValue(
        error instanceof Error ? error.message : 'An error occurred',
      )
    }
  },
)
